import React, { useState } from 'react';
import AppLayout from "@/components/layout/AppLayout";
import { AdminPerformanceInterface } from '@/components/performance/AdminPerformanceInterface';
import { ClientPerformanceView } from '@/pages/clients/components/ClientPerformanceView';
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { AddBehaviorModal } from "@/components/behavior/AddBehaviorModal";
import { useUserRoles } from "@/hooks/useUserRoles";
import { useSupabaseUser } from "@/hooks/use-supabase-user";
import { SuccessGuide } from "@/components/performance/SuccessGuide";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useLanguage } from "@/contexts/LanguageContext";

const PerformancePage: React.FC = () => {
  const [showBehaviorModal, setShowBehaviorModal] = useState(false);
  const {
    isAdmin,
    hasRole
  } = useUserRoles();
  const {
    user
  } = useSupabaseUser();
  const { t } = useLanguage();
  const isClient = hasRole('client');
  const canAddBehavior = isAdmin || hasRole('manager');
  
  return <AppLayout>
      <div className="px-10 py-10">
        {/* Show different interfaces based on user role */}
        {isClient ? (
          <ClientPerformanceView clientId={user?.id || ""} />
        ) : (
          <Tabs defaultValue="performance" className="w-full">
            <TabsList className="grid w-full grid-cols-2">
              <TabsTrigger value="performance">{t("performanceManagement") || "Διαχείριση Αξιολογήσεων"}</TabsTrigger>
              <TabsTrigger value="guide">{t("successGuide") || "Οδηγός Επιτυχίας"}</TabsTrigger>
            </TabsList>
            <TabsContent value="performance">
              <AdminPerformanceInterface />
            </TabsContent>
            <TabsContent value="guide">
              <SuccessGuide />
            </TabsContent>
          </Tabs>
        )}

        {/* Behavior Modal (only for admin/managers) */}
        {canAddBehavior && <AddBehaviorModal open={showBehaviorModal} onOpenChange={setShowBehaviorModal} />}
      </div>
    </AppLayout>;
};
export default PerformancePage;
